import GeoRegionSelect from "../../geo/widgets/GeoRegionSelect";
import { formatRegionFilterLabel } from "../../geo/lib/regionLabels";
import { applyCanonicalRegionSelection } from "../lib/searchFilterContract";

// Canonical KATOTTG Region picker for public Search/Map filters (RIC-5.6D2).
// Searchable combobox; KATOTTG `region_code` transport is unchanged.

function CanonicalRegionFilterSelect({
  filters,
  onChange,
  id = "sf-region-code",
}) {
  const regionCode = (filters.region_code || "").trim();
  const selected = regionCode ? { code: regionCode, name: regionCode } : null;

  return (
    <GeoRegionSelect
      id={id}
      value={selected}
      onChange={(region) => {
        onChange(applyCanonicalRegionSelection(filters, region?.code || ""));
      }}
      allowEmpty
      emptyOptionLabel="Усі регіони"
      formatOptionLabel={formatRegionFilterLabel}
      placeholder="Усі регіони"
      aria-label="Область / регіон"
    />
  );
}

export default CanonicalRegionFilterSelect;
